import React from 'react';
import { FcSalesPerformance } from 'react-icons/fc';
import Card from './Card';

function LatteryCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="قرعه کشی" icon={FcSalesPerformance}>
        </Card>
    );
}
export default LatteryCard;